import React, { Component } from 'react'
import {  Container } from 'semantic-ui-react'


class Privacy extends Component {

  // state = { }


  render() {

  return (
    <Container className='home'>
    <h1>Blue Sky Paint</h1>

    <h2>Privacy policy</h2>

    <p>If available, we use your device’s name to generate your username, which is seen by other users
<br /><br />
We store your drawings with their GPS coordinates so other users in your area can find them
<br /><br />
We do not share your data with 3rd parties or advertisers
</p>
    </Container>
  )

  }
}


export default Privacy



// WEBPACK FOOTER //
// ./src/components/pages/Privacy.js